import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

/**
 * Controlador para la vista de parámetros del sistema
 * Maneja la lógica de listado, eliminación y navegación de parámetros
 */
export default class ParametrosViewController {
  constructor() {
    this.parametros = [];
    this.loading = true;
    this.error = null;
  }

  /**
   * Inicializa el controlador
   */
  initialize() {
    this.loadParametros();
  }

  /**
   * Carga la lista de parámetros desde la API
   */
  async loadParametros() {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await post(getApiUrl('/api/Parametro/listar'), {});
      this.parametros = response.data;
      this.loading = false;
    } catch (error) {
      console.error('Error al cargar parámetros:', error);
      this.error = 'No se pudieron cargar los parámetros. Por favor, intente nuevamente.';
      this.loading = false;
    }
  }

  /**
   * Elimina un parámetro
   * @param {Object} parametro - El parámetro a eliminar
   * @returns {Promise} - Promesa que resuelve con la respuesta de la API
   */
  async deleteParametro(parametro) {
    console.log('Ejecutando eliminación para:', parametro.ParametroClave);
    
    const claveParametro = parametro.ParametroClave;
    console.log('Enviando clave directamente:', claveParametro);
    
    try {
      const response = await post(
        getApiUrl('/api/Parametro/borrar'), 
        { ParametroClave: claveParametro }, 
        {}, 
        false // no usar caché
      );
      
      console.log('Respuesta de eliminación recibida:', response);
      return response;
    } catch (error) {
      console.error('Error al eliminar parámetro:', error);
      throw error;
    }
  }

  /**
   * Obtiene la lista de parámetros
   * @returns {Array} - Lista de parámetros
   */
  getParametros() {
    return this.parametros;
  }

  /**
   * Obtiene el estado de carga
   * @returns {boolean} - Estado de carga
   */
  isLoading() {
    return this.loading;
  }

  /**
   * Obtiene el error actual
   * @returns {string|null} - Error actual o null
   */
  getCurrentError() {
    return this.error;
  }

  /**
   * Verifica si hay parámetros disponibles
   * @returns {boolean} - True si hay parámetros
   */
  hasParametros() {
    return this.parametros && this.parametros.length > 0;
  }

  /**
   * Limpia el error actual
   */
  clearError() {
    this.error = null;
  }

  /**
   * Establece el estado de carga
   * @param {boolean} loading - Estado de carga
   */
  setLoading(loading) {
    this.loading = loading;
  }

  /**
   * Establece un error
   * @param {string} error - Mensaje de error
   */
  setError(error) {
    this.error = error;
  }

  /**
   * Recarga los parámetros después de una operación
   */
  async reloadParametros() {
    await this.loadParametros();
  }
}